import React, { ReactElement, FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { DimensionProps, PositionProps } from '../../Layouts/LayoutTypes'

export type TonalProps = DimensionProps &
    PositionProps & {
        backgroundColor?: string
        position?: 'relative' | 'absolute' | 'fixed'
        pointerEvents?: 'none' | 'auto' | 'box-none' | 'box-only'
        zIndex?: number
        onPress?: () => void
        opacity?: number
        borderRadius?: string | string[] | number | number[]
    }

const Tonal: FunctionComponent<TonalProps> = ({
    width = '100%',
    height = '100%',
    backgroundColor = 'onyx-2',
    position = 'absolute',
    pointerEvents = 'none',
    zIndex = 2,
    onPress,
    opacity = 0.7,
    borderRadius,
    ...rest
}): ReactElement => {
    return (
        <Grid
            backgroundColor={backgroundColor}
            opacity={opacity}
            width={width}
            height={height}
            position={position}
            pointerEvents={onPress ? 'auto' : pointerEvents}
            zIndex={zIndex}
            borderRadius={borderRadius}
            {...rest}
        >
            {onPress ? <Touchable onPress={onPress} activeOpacity={1} expand /> : null}
        </Grid>
    )
}

export default Tonal
